import { EMBEDDED_BROWSER_USER_AGENT_MARKERS } from '../../_constants/browser';

type BrowserEnvironment = {
  maxTouchPoints: number;
  platform: string;
  userAgent: string;
  vendor: string;
};

export function isSafariBrowser(browserName: string | null | undefined, userAgent: string): boolean {
  const normalizedBrowserName = (browserName || '').toLowerCase();
  const normalizedUserAgent = userAgent.toLowerCase();

  return (
    normalizedBrowserName === 'safari' ||
    (normalizedUserAgent.includes('safari') &&
      !normalizedUserAgent.includes('chrome') &&
      !normalizedUserAgent.includes('crios') &&
      !normalizedUserAgent.includes('android'))
  );
}

export function isEmbeddedBrowser(userAgent: string): boolean {
  const normalizedUserAgent = userAgent.toLowerCase();

  if (isIosEmbeddedBrowser(normalizedUserAgent)) {
    return true;
  }

  return EMBEDDED_BROWSER_USER_AGENT_MARKERS.some(marker => normalizedUserAgent.includes(marker));
}

export function isIosSafariBrowser({ maxTouchPoints, platform, userAgent, vendor }: BrowserEnvironment): boolean {
  const normalizedPlatform = platform.toLowerCase();
  const normalizedUserAgent = userAgent.toLowerCase();
  const normalizedVendor = vendor.toLowerCase();
  const isIosDevice =
    /iphone|ipad|ipod/.test(normalizedUserAgent) || (normalizedPlatform === 'macintel' && maxTouchPoints > 1);
  const isAppleBrowser = normalizedVendor.includes('apple');
  const isWebKit = normalizedUserAgent.includes('applewebkit');
  const hasSafariSignature = normalizedUserAgent.includes('safari') && normalizedUserAgent.includes('version/');
  const isKnownIosAlternativeBrowser = /crios|fxios|edgios|opios|opt\/|duckduckgo|ddg|yabrowser/.test(
    normalizedUserAgent
  );

  return isIosDevice && isAppleBrowser && isWebKit && hasSafariSignature && !isKnownIosAlternativeBrowser;
}

function isIosEmbeddedBrowser(userAgent: string): boolean {
  const isIosDevice = /iphone|ipad|ipod/.test(userAgent);
  const isWebKit = userAgent.includes('applewebkit');
  const isSafari = userAgent.includes('safari');
  const isCriOs = userAgent.includes('crios');
  const isFxiOs = userAgent.includes('fxios');
  const isEdgiOs = userAgent.includes('edgios');

  return isIosDevice && isWebKit && !isSafari && !isCriOs && !isFxiOs && !isEdgiOs;
}
